// config.js
export default {
  base_url:'https://pccuapi.akkuratebank.com'
}